import { Queue } from "@/types/queue";
import { MapPin } from "lucide-react";
import { useProfileData } from "@/hooks/useProfileData";

interface QueueHeaderProps {
  queue: Queue;
}

export function QueueHeader({ queue }: QueueHeaderProps) {
  const { companyAddress } = useProfileData();

  return (
    <div className="space-y-4 mb-8">
      <h2 className="text-3xl font-bold text-primary">
        {queue.name}
      </h2>
      <div className="flex items-center text-muted-foreground">
        <MapPin size={16} className="mr-2 shrink-0" />
        <span>{companyAddress || "Address not specified"}</span>
      </div>
      {queue.description && (
        <p className="text-sm text-muted-foreground bg-secondary/50 rounded-lg p-3 border border-muted/20">
          {queue.description}
        </p>
      )}
    </div>
  );
}